import styles from './GradientCheckBox.module.css';

export default function GradientCheckBox({ label, checked, onChange }) {
    return (
        <div className={styles.checkBoxWrapper} onClick={() => onChange(!checked)}>
            <div className={styles.checkBox}>
                {checked && (
                    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 9.77776L8.15385 16L22 2" fill="#FDFDFD" fillOpacity="0.992157"/>
                        <path d="M2 9.77776L8.15385 16L22 2" stroke="url(#paint0_linear_161_2)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                        <defs>
                        <linearGradient id="paint0_linear_161_2" x1="17.8678" y1="5.99174" x2="0.149587" y2="17.7507" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#56CD7A"/>
                        <stop offset="1" stopColor="#0D79FE"/>
                        </linearGradient>
                        </defs>
                    </svg>
                )}
            </div>
        </div>
    );
}